/**
 * @name PublicRoute
 * @description Componente para rotas públicas (auth) - redireciona se já autenticado
 * @author Gabriel M. Guimarães | gabrielmg7
 */

import { useLoading } from '@/contexts/LoadingContext';
import useUserContext from '@/contexts/UserContext/useUserContext';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface PublicRouteProps {
     children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
     const { userSession, userData } = useUserContext();
     const { loadingStates } = useLoading();

     // Loading durante verificação de autenticação - o loader global já cuida disso
     if (loadingStates['auth-loading']) {
          return null; // O loader global está ativo
     } // IMPORTANTE: Não redireciona se está na página de integração ou processando integração
     const isIntegrationProcessing = localStorage.getItem('auth-integration-processing');
     const currentPath = window.location.pathname;
     const isIntegrationPage = currentPath.includes('/auth/integration') || currentPath === '/login';

     if (isIntegrationProcessing || isIntegrationPage) {
          console.log('🔄 [PublicRoute] Processamento de integração ativo, permitindo acesso');
          return <>{children}</>;
     }

     // Se já está autenticado, redireciona para a página inicial
     // Relaxamos a condição: apenas session e userData são suficientes
     if (userSession && userData) {
          console.log('✅ [PublicRoute] Usuário autenticado, redirecionando para /');
          return (
               <Navigate
                    to='/'
                    replace
               />
          );
     }

     return <>{children}</>;
};
